import {HttpClient} from "../../service/httpClient/HttpClient";

export class ContactUsService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getMessageList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `contacts-us`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    getMessageDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `contacts-us/${id}`
            ).then(resolve).catch(reject)
        })
    }
}